
export default {
  name: 'AppVerifiedBuyerBadgeImage',
  props: {
    src: { type: String, required: true }
  }
};
